import { useEffect } from "react";

/*
 * Main
 */

/**
 * Sets the browser tab title while the calling component is mounted, restoring
 * the previous title on unmount.
 *
 * The title is also what the browser prints in the page header (beside the
 * date/time stamp) when a report is saved through `window.print()`, so every
 * instrument's report pages must set their own: index.html only knows the FSCI
 * name (INC-26136).
 */
export const useDocumentTitle = (title: string): void => {
    useEffect(() => {
        const previous = document.title;
        document.title = title;

        return () => {
            document.title = previous;
        };
    }, [title]);
};
